import React from 'react';

const Header = () => (
  <div className="Header jumbotron">
    <h1 className="display-2">Emoji Search</h1>
    <p className="lead">Search for emojis. Click or Enter to copy to clipboard.</p>
  </div>
);

export default Header;
